'use strict';

import vex from 'vex-js';

const config = {
    closeBtnClass: 'vex-close-btn',
    closeTarget: '.vex-close, .vex-close-btn, .vex-close-link',
    clickEvent: 'click touch',
    formRowTarget: '.o-form_row',
    modalContents: '[data-modal="terms-and-conditions-modal"]',
    triggerTarget: '.js-modal-trigger',
    vexTheme: 'vex-theme-plain no-padding-darker-theme'
};

class TermsAndConditionsModal {

    constructor() {
        if(!$(config.modalContents).length) {
            return;
        }

        this.setupClickEvents();
    }

    /**
     * Sets up all click events for the TermsAndConditionsModal component
     */
    setupClickEvents() {
        $(config.triggerTarget).on(config.clickEvent, (e) => this.handleOpenModal(e));
    }

    /**
     * Handles trigger for opening the modal
     *
     * @param {event} e
     */
    handleOpenModal(e) {
        e.preventDefault();

        let $modalContents = $(e.target)
            .closest(config.formRowTarget)
            .next(config.modalContents)
            .html();

        this.vex = vex.open({
            content: $modalContents,
            className: config.vexTheme,
            closeClassName: config.closeBtnClass
        });

        $(config.closeTarget, this.vex[0]).on(config.clickEvent, (e) => this.handleCloseDialog(e));
    }

    /**
     * Handler for when close is clicked
     *
     * @param {event} e
     */
    handleCloseDialog(e) {
        e.preventDefault();
        this.closeDialog();
    }

    /**
     * Closes the dialog associated with this instance
     */
    closeDialog() {
        vex.close(this.vex.data().vex.id);
    }
}

$(window).load(function(){
    new TermsAndConditionsModal();
});



// WEBPACK FOOTER //
// ./src/js/components/terms-and-conditions-modal.js